// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-input-token-container {
  gap: var(--spacing-small);
  width: 384px;
}
.vert-input-character-token {
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 6px;
  border: solid 2px var(--color-border);
  font-family: var(--font-family);
  font-size: var(--font-giant);
  font-weight: 400;
}
.vert-input-character-token-inactive {
  background-color: transparent;
  border-color: var(--color-neutral-light-darker);
}
.vert-input-character-token-filled {
  border-color: var(--success-color);
  color: var(--success-color);
}
.vert-two-factor-content {
  box-sizing: border-box;
}
.vert-two-fa-trigger {
  width: 100%;
}
.vert-timer-span {
  margin-left: 5px;
  display: inline-block;
}
@media only screen and (min-width: 768px) {
  .vert-two-factor-content {
    width: 100%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 768px) {
  .vert-input-token-container {
    width: 100%;
    gap: var(--spacing-extra-small);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/CheckoutModal2FA/CheckoutModal2FA.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;AACF;AAEA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;EACA,gBAAA;AAAF;AAGA;EACE,6BAAA;EACA,+CAAA;AADF;AAIA;EACE,kCAAA;EACA,2BAAA;AAFF;AAKA;EACE,sBAAA;AAHF;AAMA;EACE,WAAA;AAJF;AAOA;EACE,gBAAA;EACA,qBAAA;AALF;AAQA;EACE;IACE,WAAA;IACA,sBAAA;EANF;AACF;AASA;EACE;IACE,WAAA;IACA,+BAAA;EAPF;AACF","sourcesContent":[".vert-input-token-container {\n  gap: var(--spacing-small);\n  width: 384px;\n}\n\n.vert-input-character-token {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border-radius: 6px;\n  border: solid 2px var(--color-border);\n  font-family: var(--font-family);\n  font-size: var(--font-giant);\n  font-weight: 400;\n}\n\n.vert-input-character-token-inactive {\n  background-color: transparent;\n  border-color: var(--color-neutral-light-darker);\n}\n\n.vert-input-character-token-filled {\n  border-color: var(--success-color);\n  color: var(--success-color);\n}\n\n.vert-two-factor-content {\n  box-sizing: border-box;\n}\n\n.vert-two-fa-trigger {\n  width: 100%;\n}\n\n.vert-timer-span {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n@media only screen and (min-width: 768px) {\n  .vert-two-factor-content {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .vert-input-token-container {\n    width: 100%;\n    gap: var(--spacing-extra-small);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
